import IsLoading from "@/components/layouts/IsLoading";
import SetLinks from "@/components/layouts/SetLinks";
import Show from "@/components/layouts/Show";
import MasterGroupConfigurationList from "@/components/lists/status/MasterGroupConfigurationList";
import MasterGroupsContext from "@/contexts/data/MasterGroupsContext";
import { ConfigurationMasterGroupsTrialCreateLink } from "@/contexts/layouts/LinkContext";
import { Typography } from "@mui/material";
import { FC, useContext } from "react";


const ConfigurationMasterGroups: FC = () => {
    const { data: masterGroups } = useContext(MasterGroupsContext);

    const loading = false;
    const validating = false;

    return (
        <>
            <SetLinks 
                createTrialLink={ConfigurationMasterGroupsTrialCreateLink} 
                institutionLinkEnabled={false} 
                participantLinkEnabled={false} 
            />
            <IsLoading name="configuration-master-groups-page" loading={loading} validating={validating} />
            <Show show={!loading}>
                <Typography variant="h1" gutterBottom>
                    Configuration &mdash; MasterGroups
                </Typography>
                <MasterGroupConfigurationList 
                    data={masterGroups}
                />
            </Show>
        </>
    )
};

export default ConfigurationMasterGroups;